'use client';

import React, { ComponentProps } from 'react';
import { Link } from '@fshr/components';
import { useConfirmationModal } from '@profiles/lib/context/confirmation-modal-context';

interface LinkWithConfirmationModal extends ComponentProps<typeof Link> {
	title?: string;
	description?: string;
	cancelLabel?: string;
	continueLabel?: string;
	modalContent?: React.JSX.Element;
}

export default function LinkWithConfirmationModal({
	href,
	title,
	description,
	cancelLabel,
	continueLabel,
	modalContent,
	onClick = () => {},
	...props
}: LinkWithConfirmationModal) {
	const { showModal } = useConfirmationModal();

	const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		onClick(event);
		event.preventDefault();
		showModal({
			href: href.toString(),
			title,
			description,
			cancelLabel,
			continueLabel,
			modalContent,
		});
	};

	return <Link href={href} {...props} onClick={handleClick} />;
}
